import { Renderer, CellModel, GridModel, renderers } from "@omegagrid/grid";
import { AxisItemProps } from "../tableAdapter";
import { dom } from "@omegagrid/core";
import type { CreateCellRendererOptions } from ".";
import { Extremes, calculateExtremes } from "./extremes";
import constants from "../../../constants";

const calculateDatabarData = (model: GridModel): Extremes => {
	const colIndices = model.columns.filter(
		c => (c.properties as AxisItemProps)?.renderer === 'databar'
	).map(col => col.index);
	return calculateExtremes(model, colIndices);
}

export const createDatabarRenderer = (opt: CreateCellRendererOptions): Renderer => {
	let data: Extremes = null;
	
	return (div: HTMLDivElement, cell: CellModel) => {
		// calculate all data during render of the first cell
		data ??= calculateDatabarData(cell.model);

		renderers.BaseRenderer(div, cell);
		
		const value = cell.value as number || 0;
		const w = cell.column.width;
		const range = data.max - data.min;
		
		// Calculate zero position
		const zeroPos = w * (0 - data.min) / range;
		
		const bar = dom.createElement('div');
		const isNegative = value < 0;
		
		if (isNegative) {
			// Negative values: bar extends from value to zero
			const valuePos = w * (value - data.min) / range;
			const width = zeroPos - valuePos;
			
			dom.setPosition(bar, {t: constants.CELL_CHART_PADDING, b: constants.CELL_CHART_PADDING, l: valuePos});
			dom.setSize(bar, {w: width});
			bar.style.background = 'linear-gradient(0deg, rgba(179,39,39,1) 41%, rgba(116,25,25,1) 100%)';
		} else {
			// Positive values: bar extends from zero to value
			const valuePos = w * (value - data.min) / range;
			const width = valuePos - zeroPos;
			
			dom.setPosition(bar, {t: constants.CELL_CHART_PADDING, b: constants.CELL_CHART_PADDING, l: zeroPos});
			dom.setSize(bar, {w: width});
			bar.style.background = 'linear-gradient(0deg, rgba(58,179,39,1) 41%, rgba(33,88,19,1) 100%)';
		}
		
		div.appendChild(bar);
		
		return div;
	};
}
